import Vue from 'vue'
import { getField, updateField } from 'vuex-map-fields'
import Order from '@/models/OrderModel'
import Mtxs from '@/constants/Mutations'

import _get from 'lodash/get'

export const state = {
  showDialogInvoicePayment: false,
  showDialogInvoiceFulfillment: false,
  orders: [],
  order: {},
}
export const mutations = {
  [Mtxs.SET_INVOICE_PAYMENT_DIALOG](state, visibility) {
    state.showDialogInvoicePayment = visibility
  },
  [Mtxs.SET_INVOICE_FULFILLMENT_DIALOG](state, visibility) {
    state.showDialogInvoiceFulfillment = visibility
  },
  [Mtxs.SET_ORDERS](_, orders) {
    Order.insert({ data: orders })
  },
  [Mtxs.SET_ORDER](state, order) {
    let { id, ...data } = order
    state.order = Order.update({ id, data })
  },
  [Mtxs.UPDATE_ORDER_FIELDS](state, fields) {
    if (!state.order) {
      return
    }
    if (!state.order.fields) {
      Vue.set(state.order, 'fields', fields)
      return
    }
    Vue.set(state.order, 'fields', { ...state.order.fields, ...fields })
  },
  updateField,
}

export const getters = {
  getShowDialogInvoicePayment: (state) => state.showDialogInvoicePayment,
  getShowDialogInvoiceFulfillment: (state) =>
    state.showDialogInvoiceFulfillment,
  getOrder: (state) => state.order,
  getOrderId: (state) => state.order.id,
  getOrderDetail: (state) => (key) => _get(state.order, `fields[${key}]`), // getOrderDetail
  getOrderTotal: (state, getters) => {
    const cost = getters.getOrderDetail('Total Cost')
    return cost ? cost.toFixed(2) : ''
  },
  getOrderPaymentStatus: (state) => _get(state.order, `fields['Paid']`),
  getOrderTotalInCents: (state, getters) =>
    getters.getOrderTotal ? Number(getters.getOrderTotal) * 100 : 0,
  getField,
}

export const actions = {
  setDialogInvoicePayment({ commit }, visibility) {
    commit(Mtxs.SET_INVOICE_PAYMENT_DIALOG, visibility)
  },
  setDialogInvoiceFulfillment({ commit }, visibility) {
    commit(Mtxs.SET_INVOICE_FULFILLMENT_DIALOG, visibility)
  },
  updateOrderFields({ commit }, fields) {
    if (typeof fields !== 'object') {
      return Promise.reject('You must provide an object of fields to update')
    }
    commit(Mtxs.UPDATE_ORDER_FIELDS, fields)
  },
}
